export default {
  label: {
    tooltip: 'Renomear',
    exportTooltip: 'Baixar componentes',
    titlePlaceholder: 'Dê um título ao seu dashboard',
    chooseCardsTitle: 'Componentes',
    addCardTooltip: 'Adicionar componente',
  },
};
